/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppAccountUpdateFirstContactAutomation } from '../../axios/whatsAppAccountUpdateFirstContactAutomation'
import type {
	WhatsAppAccountUpdateFirstContactAutomationError,
	WhatsAppAccountUpdateFirstContactAutomationPathParams,
	WhatsAppAccountUpdateFirstContactAutomationRequest,
	WhatsAppAccountUpdateFirstContactAutomationResponse,
} from '../../types/WhatsAppAccountUpdateFirstContactAutomation'

export const whatsAppAccountUpdateFirstContactAutomationMutationKey = () =>
	[{ url: '/organisations/:organisationId/whatsapp-account/first-contact-automation' }] as const

export type WhatsAppAccountUpdateFirstContactAutomationMutationKey = ReturnType<
	typeof whatsAppAccountUpdateFirstContactAutomationMutationKey
>

export type WhatsAppAccountUpdateFirstContactAutomationVariables = {
	organisationId: WhatsAppAccountUpdateFirstContactAutomationPathParams['organisationId']
	data: WhatsAppAccountUpdateFirstContactAutomationRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAccountController.php WhatsAppAccountController::updateFirstContactAutomation */
export function useWhatsAppAccountUpdateFirstContactAutomation<TContext = unknown>(
	options?: UseMutationOptions<
		WhatsAppAccountUpdateFirstContactAutomationResponse,
		AxiosError<WhatsAppAccountUpdateFirstContactAutomationError>,
		WhatsAppAccountUpdateFirstContactAutomationVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: whatsAppAccountUpdateFirstContactAutomationMutationKey(),
		mutationFn: ({ organisationId, data }: WhatsAppAccountUpdateFirstContactAutomationVariables) =>
			whatsAppAccountUpdateFirstContactAutomation(organisationId, data, config).then(res => res.data),
		...options,
	})
}
